import React from "react";
import { SpanCartLoadingSpinner } from "../style/CartLoadingSpinner.style";

type Props = {};

const CartLoadingSpinner = (props: Props) => {
  return <SpanCartLoadingSpinner className="akn-cart-spinner" />;
};

export default CartLoadingSpinner;
